export class ClientError extends Error {
    status;
    payload;
    constructor({ status, type, data }) {
        super(type);
        this.name = type;
        this.status = status;
        this.payload = { type, data };
    }
}
export function newClientError(args) {
    return new ClientError(args);
}
export function isClientError(error, type) {
    return error instanceof ClientError && error.payload.type === type;
}
